export default "__VITE_ASSET__BGlCObut__"